export default __webpack_public_path__ + "static/media/Arm-straps of the Lector.cc067626.jpg";